import mail from '../images/mail.png';
import phone from '../images/phone.png';
import css from '../images/css.png';

import git from '../images/git.png';
import html from '../images/html.png';
import javascript from '../images/javascript.png';
import node from '../images/node.png';

import react from '../images/react.png';
import redux from '../images/redux.png';

import typescript from '../images/typescript.png';

import NextJS from "../images/NextJS.png";
import gitHub from "../images/gitHub.png";
import mongoDb from "../images/mongoDb.png";
import expressJS from "../images/expressJS.png";
import vsCode from "../images/visualStudioCode.png"



import circle from '../images/circle.svg';


import robotic from "../images/robot-png-33316.png";

import Ranbir from "../images/Ranbir.png"

import linkedin from "../images/linkedin.png";
import Formalclick from "../images/formalclick.png";
import interviewprime from "../images/interviewprime.png";
import naturebasket from "../images/naturebasket.png";
import typemaster from "../images/typemaster.png";
import trendymart from "../images/trendymart.png";
import prepleaf from "../images/prepleaf1.png";
export default {
  linkedin,
  mail,
  phone,
  css,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  typescript,
  circle,
  robotic,
  Ranbir,
  Formalclick,
  interviewprime,
  naturebasket,
  typemaster,
  trendymart,
  prepleaf,
  
  NextJS,
  gitHub,
  mongoDb,
  expressJS,
  vsCode
};